import { InferValueTypes } from "../service-types";
import * as actions from "./actions";
import { AllPlans } from "../../types/plan";
import { FlatItem, ChildFlatItem } from "../../types/general";
import { AllClaims } from "../../types/claim";

export enum UserAction {
  FETCH_PLANS_AND_CLAIMS = "FETCH_PLANS_AND_CLAIMS",
  FETCH_CLAIM_OPTIONS = "FETCH_CLAIM_OPTIONS",
  FETCH_ACE_CLAIM_OPTIONS = "FETCH_ACE_CLAIM_OPTIONS",
  DELETE_CLAIM = "DELETE_CLAIM",
  GET_PLANS_BY_WARRANTY_NAME = "GET_PLANS_BY_WARRANTY_NAME",
  GET_PLANS_BY_CUSTOMER_INFO = "GET_PLANS_BY_CUSTOMER_INFO",
  SET_CUSTOMER_SEARCH_INFO = "SET_CUSTOMER_SEARCH_INFO",
  CLEAR_CUSTOMER_SEARCH_INFO = "CLEAR_CUSTOMER_SEARCH_INFO",
  GET_PLANS_BY_UPLOAD_INVOICE = "GET_PLANS_BY_UPLOAD_INVOICE",
  GET_PLAN_BY_ID = "GET_PLAN_BY_ID",

  SET_PLANS = "SET_PLANS",
  SET_CLAIMS = "SET_CLAIMS",
  SET_CLAIM_OPTIONS = "SET_CLAIM_OPTIONS",
  CLEAR_CLAIM_OPTIONS = "CLEAR_CLAIM_OPTIONS",

  UPDATE_CLAIM = "UPDATE_CLAIM",
  INCREASE_PLAN_SEARCH_TRY = "INCREASE_PLAN_SEARCH_TRY",
  RESET_PLAN_SEARCH_TRY = "RESET_PLAN_SEARCH_TRY",
}

export interface ClaimsOptionsInterface {
  materialTypes: FlatItem[];
  manufacturers: FlatItem[];
  colors: FlatItem[];
  actionsTaken: FlatItem[];
  specificDamages: ChildFlatItem[];
  howDidOccur: FlatItem[];
  damageTypes: FlatItem[];
  specificLocations: FlatItem[];
}

export interface DeleteClaimInterface {
  claimId: number | string;
}

export interface DeleteAceClaimInterface {
  claimId: number | string;
}
export interface DeleteMaceClaimInterface {
  claimId: number | string;
}

export type UserState = Readonly<{
  plans: AllPlans[];
  claims: AllClaims[];
  claimOptions: ClaimsOptionsInterface;
  planSerachTry: number;
  planSearchInfo: {};
}>;

export type UserActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const UserScope = "user";
